import React from 'react';

import InputField from '../../Forms/Input/InputField';
import SelectField from '../../Forms/Input/SelectField';
import { useQzTrayCertificate } from '../../../hooks/qztray/useQzTrayCertificate';

const QzTrayCertificateGeneratorForm: React.FC = () => {
  const { form, updateField } = useQzTrayCertificate();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    updateField(
      name as keyof typeof form,
      name === 'validYears' ? Number(value) : value
    );
  };

  const handleSelectChange = (event: any) => {
    updateField('countryCode', event.target.value);
  };

  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
      <InputField
        label="Common Name (CN)"
        name="commonName"
        type="text"
        value={form.commonName}
        onChange={handleInputChange}
        placeholder="Ej. Codenova POS"
        iconKey="shield"
        required
      />

      <InputField
        label="Organización"
        name="organization"
        type="text"
        value={form.organization}
        onChange={handleInputChange}
        placeholder="Ej. Codenova"
        iconKey="building"
        required
      />

      <InputField
        label="Unidad Organizativa"
        name="organizationalUnit"
        type="text"
        value={form.organizationalUnit}
        onChange={handleInputChange}
        placeholder="Ej. Printing"
        iconKey="briefcase"
      />

      <SelectField
        label="País"
        name="countryCode"
        value={form.countryCode}
        onChange={handleSelectChange}
        iconKey="globe"
        required
        options={[
          { value: 'SV', label: 'El Salvador' },
          { value: 'GT', label: 'Guatemala' },
          { value: 'HN', label: 'Honduras' },
          { value: 'NI', label: 'Nicaragua' },
          { value: 'CR', label: 'Costa Rica' },
        ]}
      />

      <InputField
        label="Años de Vigencia"
        name="validYears"
        type="number"
        value={form.validYears}
        onChange={handleInputChange}
        min={1}
        max={30}
        iconKey="calendar"
        required
      />
    </div>
  );
};

export default QzTrayCertificateGeneratorForm;